import { useEffect, useState } from 'react';

const useStickyState = (defaultValue: string, key: string): [string, React.Dispatch<React.SetStateAction<string>>] => {
	const [value, setValue] = useState(() => {
		const stickyValue = window.localStorage.getItem(key);

		var returnValue = defaultValue;

		if (stickyValue !== null) {
			try {
				returnValue = JSON.parse(stickyValue);
			} catch (e) {
				returnValue = defaultValue;
			}
		}

		return returnValue;
	});

	useEffect(() => {
		window.localStorage.setItem(key, JSON.stringify(value));
	}, [key, value]);

	return [value, setValue];
};

export default useStickyState;
